module.exports = __webpack_public_path__ + "img/premios-derechos-humanos.466fbf67.jpg";